import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk for creating a new level
export const newLevel = createAsyncThunk(
  'userLevels/newLevel',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${apiUrl}/UserLevels/Create/`, formData, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Something went wrong';
      return rejectWithValue(errorMessage);
    }
  }
);

const userLevelSlice = createSlice({
  name: 'userLevels',
  initialState: {
    userLevels: [], // Store for all levels
    newLevelStatus: 'idle', // Status for creating a level
    newLevelError: null, // Error for creating a level
  },
  reducers: {
    resetNewLevelStatus: (state) => {
      state.newLevelStatus = 'idle';
      state.newLevelError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle newLevel action
      .addCase(newLevel.pending, (state) => {
        state.newLevelStatus = 'loading';
        state.newLevelError = null;
      })
      .addCase(newLevel.fulfilled, (state, action) => {
        state.newLevelStatus = 'succeeded';
        state.userLevels.push(action.payload); // Add new level to the list
      })
      .addCase(newLevel.rejected, (state, action) => {
        state.newLevelStatus = 'failed';
        state.newLevelError = action.payload;
      });
  },
});

export const { resetNewLevelStatus } = userLevelSlice.actions;

export default userLevelSlice.reducer;
